<template>
  <span
    class="cost-estimator-footer__estimate-unit"
    data-test-cost-estimator-footer-unit
  >
    {{yield}}
  </span>
</template>
